import React, { useState, useEffect } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { BiUserCircle } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { setUserOrganizations } from "../store/reducers/userOrganizationsSlice";
import { fetchNotifications } from "../store/reducers/notification";
import { fetchCustomPoints } from "../store/reducers/badgesDetails";
import { setSelectedOrganization } from "../store/reducers/organizationSlice";

const ChangeOrganization = () => {
  const [t] = useTranslation();
  const jwtToken = localStorage.getItem("jwt_token");
  const dispatch = useDispatch();
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const organizationId = selectedOption
    ? selectedOption.value
    : localStorage.getItem("organisation_id");
  const userId = localStorage.getItem("user_id");

  const handleSelectChange = async (selectedOption) => {
    await localStorage.setItem("organisation_id", selectedOption.value);
    await localStorage.setItem("customer_id", selectedOption.customer_id);
    await localStorage.setItem("user_role_id", selectedOption.user_role_id);
    await localStorage.setItem("user_role", selectedOption.user_role);
    dispatch(
      setSelectedOrganization({
        organisation_id: selectedOption.value,
        customer_id: selectedOption.customer_id,
        user_role_id: selectedOption.user_role_id,
        user_role: selectedOption.user_role,
      }),
    );
    setSelectedOption(selectedOption);
  };

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_URL}/login-user-connected-in-organzation`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      },
    )
      .then(async (response) => {
        const data = await response.json();
        if (response.ok) {
          const mappedOptions = data.data.map((option) => {
            return {
              label: option.name,
              value: option.organisation_id,
              customer_id: option.customer_id,
              user_role_id: option.user_role_id,
              user_role: option.role,
            };
          });
          dispatch(setUserOrganizations(data.data));
          setOptions(mappedOptions);
          const selectedOptionMatch = mappedOptions.find(
            (option) =>
              option.customer_id === +localStorage.getItem("customer_id") &&
              option.value === +localStorage.getItem("organisation_id") &&
              option.user_role_id === +localStorage.getItem("user_role_id"),
          );
          setSelectedOption(selectedOptionMatch);
        }
        return Promise.reject(data.error);
      })
      .catch((error) => {
        toast.error(error);
      });
  }, []);

  useEffect(() => {
    if (selectedOption && userId) {
      dispatch(
        fetchNotifications({
          userId,
          organizationId: selectedOption.value,
        }),
      );
      dispatch(fetchCustomPoints(+selectedOption.value));
    }
  }, [selectedOption, userId, dispatch]);

  return (
    <>
      <div className="container justify-content-center mt-2">
        <div className="text-center">
          <h3>
            <BiUserCircle size={30} />
            {t("userMenuSidebar.label.ChangeOrg")}
          </h3>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-4 col-lg-4">
          <Select
            lassName="basic-single"
            classNamePrefix="select"
            value={selectedOption}
            name="color"
            options={options}
            onChange={handleSelectChange}
          />
        </div>
      </div>
    </>
  );
};
export default ChangeOrganization;
